import React, { useEffect, useRef } from 'react';
import { Input } from 'antd';
import { SearchOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { get, isNull, isUndefined } from 'lodash';

const { Search } = Input;

// https://ant.design/components/table/#components-table-demo-custom-filter-panel
/**
 * Creates options for ant design table column to enable filtering
 *
 * * when dataIndex is equal to "*" / "" or undefined, original object is returned
 *
 * @param {*} dataIndex
 * @param {*} transform
 * @returns
 */
export const useDataGridTextFilter = (dataIndex, transform = (row) => row) => {
  const searchRef = useRef(null);

  return {
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
      visible,
    }) => {
      useEffect(() => {
        if (visible && searchRef.current) {
          setTimeout(() => searchRef.current.focus(), 100);
        }
      }, [visible]);

      return (
        <div style={{ width: 300 }}>
          <Search
            ref={searchRef}
            size="large"
            allowClear={{
              clearIcon: (
                <CloseCircleOutlined
                  onClick={() => {
                    clearFilters();
                    confirm({ closeDropdown: true });
                  }}
                />
              ),
            }}
            value={selectedKeys[0]}
            onChange={(e) =>
              setSelectedKeys(e.target.value ? [e.target.value] : [])
            }
            onSearch={() => {
              confirm({ closeDropdown: true });
            }}
          />
        </div>
      );
    },
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) => {
      const data = transform(get(record, dataIndex, record));

      if (isUndefined(data) || isNull(data)) return false;

      return data.toString().toLowerCase().includes(value.toLowerCase());
    },
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchRef.current?.select(), 100);
        }
      },
    },
    sorter: (recordA, recordB) => {
      //Získa hodnotu z recordA/recordB pomocou dataIndex a aplikuje na ňu funkciu transform.
      //Ak hodnota neexistuje, použije prázdny reťazec ako predvolenú hodnotu
      const valueA = transform(get(recordA, dataIndex, ''));
      const valueB = transform(get(recordB, dataIndex, ''));

      // Funkcia na kontrolu, či je hodnota null, undefined alebo obsahuje len prázdne znaky
      const isEmpty = (value) =>
        isNull(value) || isUndefined(value) || value.toString().trim() === '';

      // Zabezpečí, aby prázdne hodnoty boli zoradené na konci
      //Ak je hodnota valueA prázdna podľa definície funkcie isEmpty, vráti 1
      //Toto zabezpečí, že záznam recordA bude zoradený za recordB
      if (isEmpty(valueA)) return 1;
      if (isEmpty(valueB)) return -1;

      // Porovná hodnoty pomocou localeCompare(ak ani jedna nieje prázdna), aby sa zoradili abecedne
      return valueA.toString().localeCompare(valueB.toString());
    },
  };
};
